<template>
  <div>
    <h3 :class="twMerge('text-lg font-bold mb-2', titleClasses)">
      {{ question }}
      <template v-if="maxSelectedAnswers">
        {{ __('profile-questions.questions.max-selected-answers-title', {count: maxSelectedAnswers}) }}
      </template>
    </h3>
    <div>
      <label
        v-for="answer in answers"
        :key="answer.id"
        class="flex"
      >
        <input
          v-model="model"
          class="self-start mt-1"
          type="checkbox"
          :value="answer.id"
        >
        <span class="ml-2">{{ answer.answer }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { twMerge } from 'tailwind-merge';

export default {
  props: {
    modelValue: {
      type: Array,
      required: false,
      default: () => [],
    },

    question: {
      type: String,
      required: true,
    },

    maxSelectedAnswers: {
      type: Number,
      required: false,
      default: 0,
    },

    answers: {
      type: Object,
      required: true,
    },

    titleClasses: {
      type: String,
      required: false,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  computed:{
    model:{
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    twMerge,
  },
};
</script>
